import { TableHeadersType } from "../../tableHeadersConstants/tableHeadersType";

export const OPEN_POSITION_HEADERS: TableHeadersType[] = [
  {
    label: "Position Name",
    value: "position_name",
  },
    {
      label: "Department",
      value: "department",
    },
   
    {
      label: "Status",
      value: "status",
    },
    {
      label: "CREATED/MODIFIED BY",
      value: "created_at",
    },
    {

      label: "ACTION",
      value: "Edit",
    },
  ];

  export const RECRUITMENT_MODULE_HEADERS: TableHeadersType[] = [
    {
      label: "Unique Id",
      value: "unique_id",
    },
    {
      label: "Application date",
      value: "applicantion_date",
    },
      {
        label: "Candidate name",
        value: "name",
      },
      {
        label: "Experience",
        value: "years_of_experience",
      },
      {
        label: "Applied for",
        value: "job_position",
      },
      {
        label: "Job Location",
        value: "job_location",
      },
      {
        label: "Notice Period",
        value: "notice_period",
      },
      {
        label: "Recruiter",
        value: "recruiter",
      },
      {
        label: "Gender",
        value: "gender",
      },
      {
        label: "Progress",
        value: "progress",
      },
      {
        label: "Created In Finac",
        value: "created_finac",
      },
      {
        "label": "ADDED/MODIFIED BY",
        "value": "updated_by",
      },
      {
  
        label: "ACTION",
        value: "Edit",
      },
    ];

    
    export const STICKY_HIRING_CHECKLIST_HEADERS :TableHeadersType[]=[
      {
        label: "                                                                                                                                                  Candidate name",
        value: "name",
      },
    ]
    export const HIRING_CHECKLIST_HEADERS: TableHeadersType[] = [
      
        {
          label: "Comp Discussed and Accepted on Email",
          value: "comp_discussed_accepted_email",
        },
        {
          label: "Within 30 Days Completed Background Check",
          value: "background_check_complete_within_30_days",
        },
        {
          label: "Offer Letter Signature",
          value: "offer_letter_signed",
        },
        {
          label: "Documentation",
          value: "documentation",
        },
        {
          label: "Reference Call Feedback Received",
          value: "reference_call_feedback_received",
        },
        {
          label: "Pass Book/Bank Statement (3 months) Xerox",
          value: "passbook_bank_statement_xerox",
        },
        {
          label: "Appointment Letter (Previous Organisation)",
          value: "appointment_letter_previous_org",
        },
        {
          label: "Payslip (2 months)",
          value: "payslip_last_two_months",
        },
        {
          label: "Income Tax Return",
          value: "income_tax_return",
        },
        {
          label: "Offer Letter (Previous Organisation)",
          value: "offer_letter_previous_org",
        },
        {
          label: "Relieving Letter (Previous Organisation)",
          value: "relieving_letter_previous_org",
        },
        {
          label: "Experience Letter (Previous Organisation)",
          value: "experience_letter_previous_org",
        },
        {
          label: "ICAI Intimation",
          value: "icai_intimation",
        },
        {
          label: "Filing up HRIS Form and Laptop Form",
          value: "hris_form_filled",
        },
        {
          label: "Finac Knowledge",
          value: "finac_knowledge",
        },
        {
          label: "Holiday List",
          value: "holiday_list",
        },
        {
          label: "HR Policies",
          value: "hr_policies",
        },
        {
          label: "PTO Tool",
          value: "pto_tool",
        },
        {
          label: "Stationary Items",
          value: "stationary_items",
        },
        {
          label: "Email ID Creation",
          "value": "email_id_creation",
        },
        {
          label: "Employee Code",
          "value": "employee_code",
        },
      ];